import { jitsuAnalytics, type AnalyticsInterface, type JSONObject } from '@jitsu/js'
import constants from '~/common/config/config'

let _jitsuClient: AnalyticsInterface | undefined
let _lastIdentifiedUserId: string | undefined
let _lastIdentifiedUserTraits: JSONObject | undefined

const getJitsuClient = (): AnalyticsInterface | undefined => {
  if (_jitsuClient) {
    return _jitsuClient
  }

  const { jitsuHost, jitsuWriteKey, analyticsJitsuEnabled } = constants
  if (!analyticsJitsuEnabled || !jitsuHost || !jitsuWriteKey) {
    return undefined
  }

  _jitsuClient = jitsuAnalytics({
    host: jitsuHost,
    writeKey: jitsuWriteKey,
  })
  return _jitsuClient
}

export const identifyJitsuUser = (userId: string, traits: JSONObject): void => {
  _lastIdentifiedUserId = userId
  _lastIdentifiedUserTraits = traits
  const client = getJitsuClient()
  if (!client) {
    return
  }
  void client.identify(userId, traits).catch((error: unknown) => {
    console.error('[jitsu-web] Failed to identify user:', { userId, error })
  })
}

export const pageJitsu = (): void => {
  const client = getJitsuClient()
  if (!client) {
    return
  }
  void client.page().catch((error: unknown) => {
    console.error('[jitsu-web] Failed to send page view:', error)
  })
}

export const trackJitsuEvent = (eventName: string, properties: JSONObject): void => {
  const client = getJitsuClient()
  if (!client) {
    return
  }
  const userId = _lastIdentifiedUserId
  // userId is only set after identifyJitsuUser is called; events before that are intentionally dropped
  if (!userId) {
    return
  }
  const mergedProperties = { ..._lastIdentifiedUserTraits, ...properties }
  void client.track(eventName, mergedProperties, { userId }).catch((error: unknown) => {
    console.error('[jitsu-web] Failed to send event:', { eventName, error })
  })
}
